import { lazy } from 'react';

// project-imports
import MainLayout from 'layout/MainLayout';
// import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import * as store from 'store';

// render - dashboar
const Camera = Loadable(lazy(() => import('pages/apps/camera/camera')));

// table routing
// const MuiTableBasic = Loadable(lazy(() => import('pages/tables/mui-table/basic')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'upload',
          element: <Camera {...store} />
        }
      ]
    }
  ]
};

export default MainRoutes;
